/** Insights dashboard palette (design): access points blue, nodes amber; strong = active / acknowledged. */
export const INSIGHTS_COLORS = {
    apActive: "#368ADF",
    apInactive: "#CDE4F7",
    nodeActive: "#F8AA00",
    nodeInactive: "#FDEBC0",
    acknowledged: "#2E6FDB",
    unacknowledged: "#F8AA00",
    barTop: "#2A66D6",
    barBottom: "#4C8EEA",
    grid: "#E9EDF2",
    tick: "#8A94A6",
};
export const TOOLTIP_STYLE = {
    backgroundColor: "rgba(31, 41, 55, 0.92)",
    titleColor: "#FFFFFF",
    bodyColor: "#FFFFFF",
    cornerRadius: 8,
    padding: 10,
};
/**
 * A y axis with 4-5 round steps, like the design (max 33 -> 0..40 by 10, max 49 -> 0..50 by 10); small values step by 1.
 */
export const niceScale = (values) => {
    var _a;
    const max = Math.max(0, ...values);
    if (max <= 4)
        return { max: 4, stepSize: 1 };
    const raw = max / 5;
    const magnitude = Math.pow(10, Math.floor(Math.log10(raw)));
    const step = (_a = [1, 2, 5, 10].map((m) => m * magnitude).find((s) => s >= raw)) !== null && _a !== void 0 ? _a : 10 * magnitude;
    return { max: Math.max(4, Math.ceil(max / step)) * step, stepSize: step };
};
/** "Greenhouse" -> "Greenh..." when there are many bars, so the axis labels do not overlap. */
export const truncateLabel = (label, maxChars) => label.length > maxChars ? `${label.slice(0, Math.max(1, maxChars - 1))}…` : label;
